/* Cuestionario de la página (sections/encuesta + snippets/encuesta-bloque). Sin dependencias.
   1) Convierte las respuestas en etiquetas «encuesta:<clave>:<valor>» y en una nota legible para el cliente de
      Shopify (campos contact[tags] y contact[note] del formulario de clientes).
   2) Preguntas condicionales (data-mostrar-si), tope de opciones (data-max), campo «Otra:», al menos una casilla
      en las obligatorias, contador de respondidas.
   3) Borrador en sessionStorage: si Shopify devuelve un error (correo inválido), las respuestas no se pierden.
   4) En la pantalla de gracias, botón «Copiar» del código.
   Nunca llama a form.submit(): el envío lo inicia la persona, para que el captcha de Shopify ponga su token. */
(function () {
  var sec = document.querySelector('[data-encuesta]');
  if (!sec) return;
  var form = document.getElementById('encuesta');
  var version = sec.getAttribute('data-version') || '';
  var ETQ = sec.getAttribute('data-etiqueta') || 'encuesta';
  var BORRADOR = 'moons:' + ETQ + ':' + version;

  function guarda(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function lee(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function borra(k) { try { sessionStorage.removeItem(k); } catch (e) {} }

  /* ---------- Gracias: copiar el código ---------- */
  var gracias = sec.querySelector('[data-encuesta-gracias]');
  if (gracias) {
    borra(BORRADOR);
    try { localStorage.setItem('moons:' + ETQ + ':respondida', version || '1'); } catch (e) {}
    var premio = sec.querySelector('.encuesta__premio');
    if (premio) premio.hidden = true;
    var copiar = sec.querySelector('[data-copiar]');
    var codigo = sec.querySelector('[data-codigo]');
    if (copiar && codigo && navigator.clipboard) {
      copiar.addEventListener('click', function () {
        var original = copiar.textContent;
        navigator.clipboard.writeText(codigo.textContent.trim()).then(function () {
          copiar.textContent = copiar.getAttribute('data-copiado') || original;
          setTimeout(function () { copiar.textContent = original; }, 2000);
        }, function () {});
      });
    } else if (copiar) {
      copiar.hidden = true;
    }
    try { gracias.focus({ preventScroll: false }); } catch (e) {}
    return;
  }
  if (!form) return;

  var tags = form.querySelector('[data-encuesta-tags]');
  var note = form.querySelector('[data-encuesta-note]');
  var bloques = [].slice.call(form.querySelectorAll('[data-bloque]'));
  var progreso = form.querySelector('[data-encuesta-progreso]');
  var ig = form.querySelector('[data-encuesta-ig]');
  var contactar = form.querySelector('[data-encuesta-contactar]');
  var suscribir = form.querySelector('[data-encuesta-suscribir]');
  var estado = form.querySelector('[data-encuesta-estado]');
  var textoEnTags = sec.getAttribute('data-texto-en-tags') === 'true';
  var pedidos = sec.getAttribute('data-pedidos') || '';
  var txt = {
    cabecera: sec.getAttribute('data-txt-cabecera') || 'Cuestionario [version]',
    contexto: sec.getAttribute('data-txt-contexto') || 'Desde [dispositivo] · llegó por [origen]',
    contactar: sec.getAttribute('data-txt-contactar') || 'Acepta que le escriba: sí',
    instagram: sec.getAttribute('data-txt-instagram') || 'Instagram: [usuario]',
    eligeUna: sec.getAttribute('data-txt-elige-una') || 'Elige al menos una opción.'
  };

  function slug(s) {
    return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60);
  }
  function sinComas(s) { return String(s || '').replace(/[,\r\n]+/g, ' ').replace(/\s+/g, ' ').trim(); }
  function porClave(clave) {
    for (var i = 0; i < bloques.length; i++) if (bloques[i].getAttribute('data-clave') === clave) return bloques[i];
    return null;
  }

  /* Lo que respondió en un bloque. lista: valores legibles; completa: cuenta como respondida. */
  function respuesta(b) {
    var tipo = b.getAttribute('data-tipo');
    if (tipo === 'texto') {
      var t = b.querySelector('textarea');
      var v = t ? t.value.trim() : '';
      return { lista: v ? [v] : [], completa: !!v };
    }
    if (tipo === 'escala') {
      var filas = b.querySelectorAll('.escala__grados');
      var lista = [], completas = 0;
      for (var i = 0; i < filas.length; i++) {
        var m = filas[i].querySelector('input:checked');
        if (m) { completas++; lista.push({ item: filas[i].getAttribute('data-item') || '', valor: m.value }); }
      }
      return { lista: lista, completa: filas.length > 0 && completas === filas.length };
    }
    var marcados = b.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked');
    var valores = [];
    for (var j = 0; j < marcados.length; j++) {
      if (marcados[j].value === '__otra') {
        var caja = marcados[j].closest('.opcion');
        var o = caja ? caja.querySelector('[data-otra]') : null;
        var ov = o ? o.value.trim() : '';
        if (ov) valores.push({ otra: true, texto: ov });
      } else {
        valores.push({ otra: false, texto: marcados[j].value });
      }
    }
    return { lista: valores, completa: valores.length > 0 };
  }

  function dispositivo() {
    var w = window.innerWidth || 0;
    return w < 768 ? 'celular' : (w < 1024 ? 'tableta' : 'escritorio');
  }
  function origen() {
    try {
      if (!document.referrer) return 'directo';
      var h = new URL(document.referrer).hostname.replace(/^www\./, '');
      return h === location.hostname.replace(/^www\./, '') ? 'la misma página' : h;
    } catch (e) { return 'directo'; }
  }

  /* Etiquetas y nota a partir de todo lo respondido. */
  function arma() {
    var t = [ETQ];
    if (version) t.push(ETQ + ':v:' + slug(version));
    var disp = dispositivo(), ori = origen();
    t.push(ETQ + ':dispositivo:' + disp);
    t.push(ETQ + ':origen:' + (slug(ori) || 'directo'));
    if (pedidos !== '') t.push(ETQ + ':cliente:' + (parseInt(pedidos, 10) > 0 ? 'con-pedidos' : 'sin-pedidos'));
    var lineas = [
      txt.cabecera.replace('[version]', version || '') + ' · ' + new Date().toLocaleString('es-MX'),
      txt.contexto.replace('[dispositivo]', disp).replace('[origen]', ori)
    ];
    for (var i = 0; i < bloques.length; i++) {
      var b = bloques[i];
      if (b.hidden) continue;
      var clave = b.getAttribute('data-clave'), tipo = b.getAttribute('data-tipo');
      var pregunta = b.getAttribute('data-pregunta') || clave;
      var r = respuesta(b);
      if (!r.lista.length) continue;
      var num = i + 1;
      if (tipo === 'escala') {
        var partes = [];
        for (var k = 0; k < r.lista.length; k++) {
          /* 1–5 y «sin» van tal cual; una respuesta con nombre («Lo sabía») va como slug en la etiqueta y legible en la nota. */
          var val = r.lista[k].valor, esNum = /^[1-5]$/.test(val);
          t.push(ETQ + ':' + clave + ':' + slug(r.lista[k].item) + ':' + (esNum || val === 'sin' ? val : slug(val)));
          partes.push(r.lista[k].item + ': ' + (val === 'sin' ? 'no lo usó' : (esNum ? val + '/5' : val)));
        }
        lineas.push(num + '. ' + pregunta + ' → ' + partes.join(' · '));
      } else if (tipo === 'texto') {
        if (textoEnTags) t.push(ETQ + ':' + clave + ':' + sinComas(r.lista[0]).slice(0, 200));
        lineas.push(num + '. ' + pregunta + ' → ' + r.lista[0]);
      } else {
        var legibles = [];
        for (var m = 0; m < r.lista.length; m++) {
          var v = r.lista[m];
          t.push(ETQ + ':' + clave + ':' + (v.otra ? 'otra' : slug(v.texto)));
          legibles.push(v.otra ? 'Otra: ' + v.texto : v.texto);
        }
        lineas.push(num + '. ' + pregunta + ' → ' + legibles.join(' · '));
      }
    }
    var usuario = ig ? ig.value.trim().replace(/^@/, '') : '';
    if (usuario) {
      t.push(ETQ + ':ig:' + slug(usuario));
      lineas.push(txt.instagram.replace('[usuario]', '@' + usuario));
    }
    if (contactar && contactar.checked) {
      t.push(ETQ + ':contactar');
      lineas.push(txt.contactar);
    }
    if (suscribir && suscribir.checked) t.push(ETQ + ':suscrito');
    if (tags) tags.value = t.join(', ');
    if (note) note.value = lineas.join('\n');
  }

  /* ---------- Condicionales, topes, «Otra», obligatorias, elegidas ---------- */
  function cumple(cond) {
    var p = cond.indexOf('=');
    if (p < 0) return true;
    var clave = cond.slice(0, p).trim();
    var valores = cond.slice(p + 1).split('|').map(function (x) { return x.trim(); }).filter(Boolean);
    var b = porClave(clave);
    if (!b) return true;
    var r = respuesta(b);
    for (var i = 0; i < r.lista.length; i++) {
      var v = typeof r.lista[i] === 'string' ? r.lista[i] : (r.lista[i].texto || r.lista[i].valor || '');
      if (valores.indexOf(v) >= 0) return true;
    }
    return false;
  }

  function aplicaCondicionales() {
    for (var i = 0; i < bloques.length; i++) {
      var b = bloques[i];
      var cond = b.getAttribute('data-mostrar-si');
      if (!cond) continue;
      var mostrar = cumple(cond);
      if (mostrar === !b.hidden) continue;
      b.hidden = !mostrar;
      var campos = b.querySelectorAll('input, textarea');
      for (var j = 0; j < campos.length; j++) {
        var c = campos[j];
        if (mostrar) {
          if (c.getAttribute('data-req') === '1') c.required = true;
        } else {
          if (c.required) { c.setAttribute('data-req', '1'); c.required = false; }
          c.setCustomValidity('');
        }
      }
    }
  }

  function aplicaTopes() {
    var cajas = form.querySelectorAll('[data-max]');
    for (var i = 0; i < cajas.length; i++) {
      var caja = cajas[i];
      var max = parseInt(caja.getAttribute('data-max'), 10) || 0;
      var entradas = caja.querySelectorAll('input[type="checkbox"]');
      var marcadas = caja.querySelectorAll('input[type="checkbox"]:checked').length;
      for (var j = 0; j < entradas.length; j++) {
        var apagar = max > 0 && marcadas >= max && !entradas[j].checked;
        entradas[j].disabled = apagar;
        var lab = entradas[j].closest('.opcion');
        if (lab) lab.classList.toggle('is-apagada', apagar);
      }
      var cuenta = caja.parentNode.querySelector('[data-cuenta]');
      if (cuenta && max > 0) cuenta.textContent = (cuenta.getAttribute('data-plantilla') || '[n]').replace('[n]', marcadas);
    }
  }

  function aplicaOtra() {
    var otras = form.querySelectorAll('[data-otra]');
    for (var i = 0; i < otras.length; i++) {
      var campo = otras[i];
      var caja = campo.closest('.opcion');
      var marca = caja ? caja.querySelector('input[type="radio"], input[type="checkbox"]') : null;
      var activa = !!(marca && marca.checked);
      campo.required = activa;
      campo.disabled = !activa;
    }
  }

  function aplicaObligatorias() {
    for (var i = 0; i < bloques.length; i++) {
      var b = bloques[i];
      if (b.getAttribute('data-tipo') !== 'multiple' || !b.hasAttribute('data-obligatoria')) continue;
      var casillas = b.querySelectorAll('input[type="checkbox"]');
      if (!casillas.length) continue;
      var alguna = b.querySelector('input[type="checkbox"]:checked');
      casillas[0].setCustomValidity(!b.hidden && !alguna ? txt.eligeUna : '');
    }
  }

  function aplicaElegidas() {
    var cajas = form.querySelectorAll('.opcion, .grado');
    for (var i = 0; i < cajas.length; i++) {
      var entrada = cajas[i].querySelector('input[type="radio"], input[type="checkbox"]');
      cajas[i].classList.toggle('is-elegida', !!(entrada && entrada.checked));
    }
  }

  function aplicaProgreso() {
    if (!progreso) return;
    var total = 0, hechas = 0;
    for (var i = 0; i < bloques.length; i++) {
      if (bloques[i].hidden) continue;
      total++;
      if (respuesta(bloques[i]).completa) hechas++;
    }
    progreso.textContent = (progreso.getAttribute('data-plantilla') || '[n] de [total]').replace('[n]', hechas).replace('[total]', total);
  }

  /* ---------- Borrador ---------- */
  function guardaBorrador() {
    var d = {};
    var campos = form.querySelectorAll('input[name^="p-"], textarea[name^="p-"], [data-otra], [data-encuesta-ig], [data-encuesta-contactar], [data-encuesta-suscribir]');
    for (var i = 0; i < campos.length; i++) {
      var c = campos[i];
      var k = c.hasAttribute('data-encuesta-suscribir') ? 'suscribir' : (c.name || c.getAttribute('data-otra') !== null && ('otra:' + (c.closest('[data-bloque]') || {}).getAttribute('data-clave')) || (c.hasAttribute('data-encuesta-ig') ? 'ig' : 'contactar'));
      if (c.type === 'radio') { if (c.checked) d[k] = c.value; }
      else if (c.type === 'checkbox') { if (!d[k]) d[k] = []; if (c.checked) d[k].push(c.value || 'on'); }
      else if (c.value) d[k] = c.value;
    }
    guarda(BORRADOR, JSON.stringify(d));
  }

  function restauraBorrador() {
    var crudo = lee(BORRADOR);
    if (!crudo) return;
    var d;
    try { d = JSON.parse(crudo); } catch (e) { return; }
    var campos = form.querySelectorAll('input[name^="p-"], textarea[name^="p-"], [data-otra], [data-encuesta-ig], [data-encuesta-contactar], [data-encuesta-suscribir]');
    for (var i = 0; i < campos.length; i++) {
      var c = campos[i];
      var k = c.hasAttribute('data-encuesta-suscribir') ? 'suscribir' : (c.name || c.getAttribute('data-otra') !== null && ('otra:' + (c.closest('[data-bloque]') || {}).getAttribute('data-clave')) || (c.hasAttribute('data-encuesta-ig') ? 'ig' : 'contactar'));
      if (!(k in d)) continue;
      if (c.type === 'radio') c.checked = d[k] === c.value;
      else if (c.type === 'checkbox') c.checked = Array.isArray(d[k]) && d[k].indexOf(c.value || 'on') >= 0;
      else c.value = d[k];
    }
  }

  function todo() {
    aplicaCondicionales();
    aplicaTopes();
    aplicaOtra();
    aplicaObligatorias();
    aplicaElegidas();
    aplicaProgreso();
  }

  form.addEventListener('change', function () { todo(); guardaBorrador(); });
  form.addEventListener('input', function (e) {
    if (e.target && (e.target.tagName === 'TEXTAREA' || e.target.type === 'text')) { aplicaProgreso(); guardaBorrador(); }
  });
  form.addEventListener('submit', function () {
    arma();
    guardaBorrador();
  });

  restauraBorrador();
  todo();
  if (estado) { try { estado.focus(); } catch (e) {} }
})();
